import { useLazyQuery } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { BsPlusCircleFill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { replaceUnderscore } from "../../../CommonFunction/common";
import { AdditionalConfig } from "../Input/ConfigObject";
import "./InputDropdown.scss";
import { RiEditCircleFill } from "react-icons/ri";
import { useRecoilState } from "recoil";
import { AtomFormState } from "../../../atoms/FormAtom";

const InputDropdownForQuery = ({
  Section_Type,
  searchText,
  setSearchText,
  inputcontent,
  name,
  InputConfig,
  detectBlur,
  setBlur,
  formkey,
  AddNew,
  width,
  RowId,
  handleDropDownClose,
  id,
}) => {
  const keyboardNavRef = useRef(false);
  const rowRefs = useRef([]); // ← holds each <tr> element
  let masterName = InputConfig?.masterName;
  let queryName = AdditionalConfig[masterName]?.dropdowndata;
  let EMTQuery = AdditionalConfig[masterName]?.EMTQuery;
  const [formValue] = useRecoilState(AtomFormState(formkey));
  // console.log(queryName);
  let variable = InputConfig.variable ? InputConfig.variable : {};
  // console.log(formValue, "variable");
  const [GetDropData, { data: searchedData, loading: dropdownLoading }] = useLazyQuery(queryName, {
    variables: {
      keyword: searchText || "",
      ...variable,
    },
    fetchPolicy: "network-only",
    context: EMTQuery,
  });
  const Master = useSelector((store) => store?.FormDataReducer?.MasterData);

  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState(-1);
  const [data, setData] = useState([]);
  const [firstData, setFirstData] = useState();
  const [count, setCount] = useState(0);
  const [selectId, setSeledId] = useState(null);

  const FormData = useSelector((store) => store?.FormDataReducer);

  useEffect(() => {
    const masterValue = RowId
      ? Master?.[formkey]?.[RowId]?.[name]?.Search_Value
      : Master?.[formkey]?.[name]?.Search_Value;
    const RowIdValue = RowId ? Master?.[formkey]?.[RowId]?.[name]?._id : Master?.[formkey]?.[name]?._id;
    console.log(masterValue, Master?.[formkey]?.[name]);
    // Only update inputcontent if masterValue has changed and is different from searchText
    if (masterValue !== undefined && masterValue !== searchText) {
      const event = {
        target: {
          name: name, // Ensure this uses the correct "name" of the input
          value: masterValue,
        },
      };
      inputcontent(event);
      setSeledId(RowIdValue);
    }
  }, [
    Master?.[formkey]?.[RowId]?.[name]?.Search_Value,
    Master?.[formkey]?.[name]?.Search_Value,
    Master?.[formkey]?.[RowId]?.[name]?._id,
    Master?.[formkey]?.[name]?._id,
  ]);

  useEffect(() => {
    if (searchText && detectBlur && (!Master[formkey] || !Master[formkey][name])) {
      setSelectedOption(0);
      dispatch({
        type: RowId ? "StoreMasterDataForRow" : "StoreMasterData",
        payload: {
          formkey,
          rowId: RowId,
          data: {
            [name]: data[0] || firstData,
          },
        },
      });
      // inputcontent(data[0]?.Search_Value);
    }
    setBlur(false);
  }, [detectBlur, searchText]);

  useEffect(() => {
    if (keyboardNavRef.current) {
      if (searchText) {
        keyboardNavRef.current = false;
      }
      return;
    }
    let lookField = InputConfig.name == "Load_Manager" ? "UserId" : "_id";
    if (
      (InputConfig?.Reference_field && Master[formkey] && Master[formkey]?.[InputConfig?.Reference_field?.[0]]) ||
      (InputConfig?.Reference_field &&
        FormData?.[formkey] &&
        FormData?.[formkey]?.["Contact_Person_Master_Details"]?.[InputConfig?.Reference_field?.[0]]) ||
      InputConfig?.Reference_field?.[0] == "Mode" ||
      InputConfig?.Reference_field?.[1] == "Customer_Account" ||
      InputConfig?.Reference_field?.[0] == "Freight_Type"
    ) {
      // console.log(InputConfig?.Reference_field);
      let searchId = Master?.[formkey]?.[InputConfig?.Reference_field[0]]?.[lookField];
      // console.log(searchId, "searchIdsearchId");
      let contactPersonFor = FormData
        ? FormData?.[formkey]?.["Contact_Person_Master_Details"]?.[InputConfig?.Reference_field?.[0]]
        : "";
      const [key, test, value] = InputConfig?.Reference_field;
      const quary_var = {};
      if (Array.isArray(value)) {
        value?.forEach((el, index) => {
          const property = index === 0 ? "SearchId" : `SearchId${index}`;
          quary_var[property] = Master?.[formkey]?.[key]?.[el];
        });
      }
      console.log(InputConfig, formValue, "formValueformValue");
      searchId = Master?.[formkey]?.[key]?.[value || "_id"];

      let consignorSel =
        InputConfig?.Reference_field?.[1] == "Customer_Account" && Master["Consignment_Note"]?.Consignor?._id
          ? Master["Consignment_Note"]?.Consignor?._id
          : InputConfig?.Reference_field?.[1] == "Customer_Account" && Master["FTL_Consignment_Note"]?.Consignor?._id
          ? Master["FTL_Consignment_Note"]?.Consignor?._id
          : undefined;
      GetDropData({
        variables: {
          keyword: searchText || "",
          SearchId: searchId,
          ...quary_var,
          contactPersonFor: FormData && FormData[formkey] ? contactPersonFor : "",
          Type: InputConfig?.Reference_field?.[0] == "Mode" && formValue?.Mode,
          FreightType: InputConfig?.Reference_field?.[0] == "Freight_Type" && formValue?.Freight_Type,
          consignor: consignorSel,
        },
        fetchPolicy: "network-only",
      });
    } else {
      GetDropData({
        variables: {
          keyword: searchText || "",
        },
        fetchPolicy: "network-only",
      });
    }
  }, [searchText, InputConfig]);

  useEffect(() => {
    if (searchedData && Object.values(searchedData)[0]) {
      setData(searchedData && Object.values(searchedData)[0]);
    }
  }, [searchedData]);

  useEffect(() => {
    if (!firstData && data[0]) {
      setFirstData(data[0]);
    }
  }, [data]);

  useEffect(() => {
    if (keyboardNavRef.current) {
      const el = rowRefs.current[selectedOption];
      if (el) el.scrollIntoView({ block: "nearest", behavior: "smooth" });
      // keyboardNavRef.current = false;
    }
  }, [selectedOption]);

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.keyCode === 38 || event.keyCode === 40) {
        keyboardNavRef.current = true;
        setSearchText("");
      }
      if (
        (event.keyCode === 9 && count === 0) ||
        (event.keyCode !== 38 && event.keyCode !== 40 && event.keyCode !== 8 && event.keyCode !== 13)
      ) {
        return;
      }
      if (event.keyCode === 38) {
        if (selectedOption > 0) {
          setSelectedOption((prevOption) => prevOption - 1);
          dispatch({
            type: RowId ? "StoreMasterDataForRow" : "StoreMasterData",
            payload: {
              formkey,
              rowId: RowId,
              data: { [name]: data[selectedOption - 1] },
            },
          });

          event.preventDefault();
        } else {
          // to select last row
          const lastIndex = data.length - 1;
          setSelectedOption(lastIndex);
          dispatch({
            type: RowId ? "StoreMasterDataForRow" : "StoreMasterData",
            payload: {
              formkey,
              rowId: RowId,
              data: { [name]: data[lastIndex] },
            },
          });
        }
      } else if (event.keyCode === 40) {
        if (data.length - 1 !== selectedOption) {
          setSelectedOption((prevOption) => prevOption + 1);
          console.log(event, "eventeventeventeventeventevent", data[selectedOption + 1]);
          if (typeof data === "object" && data[selectedOption + 1]?.Search_Value) {
            dispatch({
              type: RowId ? "StoreMasterDataForRow" : "StoreMasterData",
              payload: {
                formkey,
                rowId: RowId,
                data: { [name]: data[selectedOption + 1] },
              },
            });
          } else {
            dispatch({
              type: RowId ? "StoreMasterDataForRow" : "StoreMasterData",
              payload: {
                formkey,
                rowId: RowId,
                data: { [name]: data[selectedOption + 1] },
              },
            });
          }
          event.preventDefault();
        } else {
          dispatch({
            type: RowId ? "StoreMasterDataForRow" : "StoreMasterData",
            payload: {
              formkey,
              rowId: RowId,
              data: { [name]: data[0] },
            },
          });

          event.preventDefault();
        }
      } else if (event.keyCode === 13) {
        handleDropDownClose();
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedOption, data]);
  useEffect(() => {
    // once you have both a saved ID *and* some rows, find its index
    if (data.length > 0 && selectId) {
      const idx = data.findIndex((el) => el._id === selectId);
      if (idx >= 0) setSelectedOption(idx);
    }
  }, [data, selectId]);

  // Build header keys
  const getHeaderKeys = (data) => {
    let headers = [];
    if (data && data.length > 0) {
      data.forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (
            !headers.includes(key) &&
            key !== "__typename" &&
            key !== "_id" &&
            key !== "Search_Value" &&
            (typeof item[key] !== "object" || item[key] == null)
          ) {
            headers.push(key);
          }
        });
      });
    }
    return headers.slice(0, InputConfig.fieldCount || 3);
  };

  const headerKeys = getHeaderKeys(data);

  // If no rows & not loading, show “Data Not Found” + an Add button
  if (data?.length < 1 && !dropdownLoading) {
    return (
      <div style={{ minWidth: width ? width : 150 }}>
        <div className="data_not_found">Data Not Found</div>
        <div className="dropdownFooterContainer">
          <div className={"dropDownFooter"}>
            <div
              onMouseDown={(e) => {
                e.preventDefault();
                AddNew(113);
              }}
            >
              <BsPlusCircleFill className="AddNewIcon" /> Add
            </div>
          </div>
        </div>
      </div>
    );
  }

  // If loading & no rows yet, show loading indicator
  if (!data.length && dropdownLoading) {
    return (
      <div style={{ minWidth: width ? width : 150 }} className="data_not_found">
        <div className="loading">
          Loading&nbsp;<span>.</span>
          <span>.</span>
          <span>.</span>
        </div>
      </div>
    );
  }

  // Otherwise, render the scrollable table + footer
  return data?.length ? (
    <div className="InputdropdownForQuery" style={{ minWidth: width ? width : 150 }}>
      {/* 1) SCROLLABLE TABLE WRAPPER */}
      <div className="tableWrapper">
        <table className="dynamic-table">
          <thead>
            <tr>
              {headerKeys.map((key, index) => (
                <th key={index}>{replaceUnderscore(key)}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => {
              // Determine whether this row is selected
              const rowClass = rowIndex === selectedOption ? "row forHoverForQuery" : "row";
              const SelectedvalueRow = selectId === row._id ? "row forHoverForQuery" : "";

              return (
                <tr
                  key={rowIndex}
                  className={`${SelectedvalueRow}`}
                  ref={(el) => (rowRefs.current[rowIndex] = el)}
                  onClick={() => {
                    console.log(name, "99999999999999999999999999999", row);
                    keyboardNavRef.current = true;
                    dispatch({
                      type: RowId ? "StoreMasterDataForRow" : "StoreMasterData",
                      payload: {
                        formkey,
                        rowId: RowId,
                        data: { [name]: row },
                      },
                    });
                    setTimeout(() => {
                      handleDropDownClose();
                    }, 100);
                  }}
                >
                  {headerKeys.map((header) => {
                    const value = row[header];
                    if (value === true) {
                      return <td key={header}>Yes</td>;
                    } else if (value === false) {
                      return <td key={header}>No</td>;
                    } else if (value !== null && typeof value !== "object") {
                      return <td key={header}>{value}</td>;
                    }
                    return <td key={header}></td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* 2) FOOTER ALWAYS VISIBLE */}
      <div className="dropdownFooterContainer">
        <div className={"dropDownFooter"}>
          <div onClick={() => AddNew(113)}>
            <BsPlusCircleFill className="AddNewIcon" /> Add
          </div>
          <div onClick={() => AddNew(117)}>
            <RiEditCircleFill className="AddEditIcon" /> Edit
          </div>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};

export default InputDropdownForQuery;
